import React, {Component} from 'react';
import {Card, CardHeader, Row, TabContent, TabPane} from "reactstrap";
import DefaultModal from "../../invoice/DefaultModal";
import {Decimal} from "decimal.js";
import ESmmPriceTable from "./ESmmPriceTable";
import Select from "../../../local_node_modules/react-select";

class ESmmPriceModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
			content:this.props.content,
            type:'ARABULUCU',
            currentYear: ((new Date().getMonth() === 0 && new Date().getDate() < 15) ? (new Date().getFullYear() - 1) : new Date().getFullYear()),
		};
		this.calculate  = this.calculate.bind(this);
	}

    activeYears = [
        {value: new Date().getFullYear(), label: new Date().getFullYear()},
        {value: (new Date().getFullYear() - 1), label: (new Date().getFullYear() - 1)},
    ];

    calculate(content){
        let {itemName, brut, stoppageAmount, kdvAmount,kdvPercentage, stoppagePercentage, withHoldingCodePercentage, withHoldingCodeAmount} = content;
        let trdDocVoucherLineCharges = [
            {
                recordId: null,
                taxCode: {
                    recordId: 2,
                    code: "0003",
                    shortName: "GV STOPAJI",
                    longName: "GELİR VERGİSİ STOPAJI",
                    direction: -1,
                    calculatedBy: "AMOUNT",
                    priority: 2,
                    affectTaxableAmount: 1,
                    mm: 1,
                    smm: 1,
                    inv: 1,
                    isAffectKdv: 0
                },
                calculateBy: "AMOUNT",
                calculateFrom: "stoppageCode",
                percentage: stoppagePercentage,
                amount: new Decimal(new Decimal(stoppageAmount).toFixed(2)).toNumber(),
                direction: -1,
                exemptionReasonCode: null,
                exemptionReason: null,
                perUnitAmount: 0,
                calculatedBy: "AMOUNT",
                taxableAmount:new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                withholdingCode: null,
                stoppageCode:(stoppagePercentage===0 ? "000" : "022")
            },
            {
                recordId: null,
                taxCode: {
                    recordId: 1,
                    code: "0015",
                    shortName: "KDV GERCEK",
                    longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                    direction: 1,
                    calculatedBy: "AMOUNT",
                    priority: 4,
                    affectTaxableAmount: 0,
                    mm: 0,
                    smm: 1,
                    inv: 1,
                    isAffectKdv: 0
                },
                calculateBy: "AMOUNT",
                calculateFrom: "percentage",
                percentage: kdvPercentage,
                amount: new Decimal(new Decimal(kdvAmount).toFixed(2)).toNumber(),
                direction: 1,
                exemptionReasonCode: null,
                exemptionReason: null,
                perUnitAmount: 0,
                calculatedBy: "AMOUNT",
                taxableAmount: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                withholdingCode: null
            },
            {
                recordId: null,
                taxCode: {
                    recordId: 6,
                    code: "9015",
                    shortName: "KDV TEVKİFATI",
                    longName: "KDV TEVKİFATI",
                    direction: -1,
                    calculatedBy: "AMOUNT",
                    priority: 5,
                    affectTaxableAmount: 0,
                    mm: 0,
                    smm: 1,
                    inv: 1,
                    isAffectKdv: 0
                },
                calculateBy: "AMOUNT",
                calculateFrom: "percentage",
                percentage: withHoldingCodePercentage,
                amount: withHoldingCodeAmount,
                direction: -1,
                exemptionReasonCode: null,
                exemptionReason: null,
                perUnitAmount: 0,
                calculatedBy: "AMOUNT",
                taxableAmount: new Decimal(new Decimal(kdvAmount).toFixed(2)).toNumber(),
                withholdingCode: "000"
            }];

        let trdDocVoucherLines= [{
            recordId: null,
            itemId: null,
            itemCode: null,
            itemName: itemName,
            quantity: 1,
            unit: "C62",
            unitPrice: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
            lineExtensionAmount: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
            note: null,
            trdDocVoucherLineCharges: trdDocVoucherLineCharges

        }];
        this.props.applyLine(trdDocVoucherLines);
    }

    render() {
		return (
			<DefaultModal disabled={this.state.btnDisabled}
                          size="xl"
						  isOpen={this.props.eSmmPriceModal}
						  title="Standart Makbuzlar"
						  confirmBtnText=""
						  cancelBtnText=""
						  onConfirm={()=>this.setState({btnDisabled:false}, () => {this.calculate(true)})}
						  onCancel={(e)=>this.setState({btnDisabled:false}, () => {this.props.toggleModal(false);})}>
                    <Row style={{paddingLeft:0, margin:"0px",paddingBottom:"10px"}}>
                        <Card className="">
                            <CardHeader>
                                <div className="nav-tabs-navigation">
                                    <div className="nav-tabs-wrapper">
                                        <ul className="nav tabBackground nav-tabs" data-tabs="tabs">
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.type === 'ARABULUCU' ? 'active' : '')}
                                                   onClick={() => {this.setState({type:"ARABULUCU"})}}
                                                   data-toggle="tab">Arabuluculuk</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.type === 'ADLIYARDIM' ? 'active' : '')}
                                                   onClick={() => {this.setState({type:"ADLIYARDIM"})}}
                                                   data-toggle="tab">Adli Yardım</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={"nav-link " + (this.state.type === 'CMK' ? 'active' : '')}
                                                   onClick={() => {this.setState({type:"CMK"})}}
                                                   data-toggle="tab">CMK</a>
                                            </li>
                                            <li className="col-sm-2 my-auto">
                                                        <Select name={"year"}
                                                                type='select'
                                                                value={this.state.currentYear}
                                                                clearable={false}
                                                                noResultsText="Veri yok"
                                                                placeholder="Yıl Seçiniz"
                                                                onChange={e => {
                                                                    this.setState({currentYear: e.value});
                                                                }}
                                                                options={this.activeYears}
                                                        />
                                            </li>
                                        </ul>
                                        <hr></hr>
                                    </div>
                                </div>
                            </CardHeader>
                            <TabContent activeTab={this.state.type}>
                                <TabPane tabId="ARABULUCU">
                                    <ESmmPriceTable
                                        loading={this.state.loading}
                                        content={this.state.content}
                                        type={this.state.type}
                                        calculate={this.calculate}
                                        selectedYear = {this.state.currentYear}
                                    />
                                </TabPane>
                                <TabPane tabId="ADLIYARDIM">
                                    <ESmmPriceTable
                                        loading={this.state.loading}
                                        content={this.state.content}
                                        type={this.state.type}
                                        calculate={this.calculate}
                                        selectedYear = {this.state.currentYear}
                                    />
                                </TabPane>
                                <TabPane tabId="CMK">
                                    <ESmmPriceTable
                                        loading={this.state.loading}
                                        content={this.state.content}
                                        type={this.state.type}
                                        calculate={this.calculate}
                                        selectedYear = {this.state.currentYear}
                                    />
                                </TabPane>
                            </TabContent>
                        </Card>
                    </Row>
			</DefaultModal>
		)
	}
}

export default ESmmPriceModal;